import cx from 'classnames';
import type { MouseEvent, VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../../../generic';
import Button, { BUTTON_TYPE } from '../../../../../generic/Button';
import type { ModalStateWithContext } from '../../../../../../hooks/useModalWithContext';
import type { StreamBuildModalState } from '../../../hooks/useDependencyModals';

import styles from './StateContextPanel.module.less';

type Props = {
  buildModal: ModalStateWithContext<StreamBuildModalState>;
  buildId?: number;
};

const BuildStatePanel: VoidFunctionComponent<Props> = ({
  buildModal,
  buildId,
}) => {
  const openBuildModal = (event: MouseEvent<HTMLElement, MouseEvent>) => {
    buildModal.onOpen({ context: { buildId } });

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return false;
  };

  return (
    <div className={cx(styles.stateContextPanel, styles.buildState)}>
      {buildId ?
        <>
          Queued: Build #{buildId}
          <Button type={BUTTON_TYPE.ANCHOR} onClick={openBuildModal}>
            <div className={styles.iconLink}>
              <span>View build</span>
              <Icon icon={icons.personDigging} />
            </div>
          </Button>
        </>
        : <>Not Building</>}
    </div>
  );
};

export default BuildStatePanel;
